import { TextField } from '@mui/material';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import fadeIn from '../../animations/fadeIn';
import Background from '../../components/Background/Background';
import Header from '../../components/Header/Header';
import useQuery from '../../hooks/useQuery';
import { motion } from 'framer-motion';
import { planeVariants } from '../../animations/plane';
import Logo from '../../components/Logo/Logo';
import Button from '../../components/Button/Button';
import { verifyAccount } from '../../api/resetPassword';
import { useAppDispatch } from '../../hooks/useApp';
import { finalizeRegistration } from '../../store/slices/authSlice';
import Modal from '../../components/Modal/Modal';

const ConfirmEmail = () => {
  const query = useQuery();
  const email = query.get('email') as string;
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState("");

  const dispatch = useAppDispatch();

  const pin1 = useRef<any>();
  const pin2 = useRef<any>();
  const pin3 = useRef<any>();
  const pin4 = useRef<any>();


  const clearPin = () => {
    pin1.current.value = "";
    pin2.current.value = "";
    pin3.current.value = "";
    pin4.current.value = "";
    setCode("");
  }

  const onPinChange = (position: number, e: any) => {
    setCode(
      `${pin1.current.value}${pin2.current.value}${pin3.current.value}${pin4.current.value}`
    );
    if (e.target.value.length === 0) {
      return;
    }
    switch (position) {
      case 1:
        pin2.current.focus();
        break;
      case 2:
        pin3.current.focus();
        break;
      case 3:
        pin4.current.focus();
        break;
      default:
        pin4.current.blur();
        break;
    }
  };

  const confirmUserEmail = async () => {
    setLoading(true);
    const data = await verifyAccount(email, code);

    if (data.success) {
      dispatch(
        finalizeRegistration({
          token: data.data.token,
          userId: data.data.user._id,
        })
      );
      setLoading(false);
      navigate('/points');
    } else {
      setHasError(data.message);
      clearPin();
      setLoading(false);
    }
  };

  return (
    <>
      <Modal visible={hasError !== "" ? true : false} onClose={() => setHasError("")}>
        <p className='text-error font-bold text-xl'>Error.</p>
        <p>{hasError}</p>
      </Modal>
      <Background image='login-bg'>
        <Header title='Confirm Email' />
        <motion.img
          initial='hidden'
          animate='enter'
          exit='exit'
          src='/plane.png'
          className='signin-plane'
          variants={planeVariants}
        />
        <div className='auth-container'>
          <motion.div
            variants={fadeIn(0.5)}
            initial='hidden'
            animate='enter'
            exit='exit'
            className='auth-logo'
          >
            <Logo name='awayz' className='max-w-[100%]' />
          </motion.div>
          <div className='w-full flex flex-col gap-6 items-center'>
            <motion.p
              variants={fadeIn(0.45)}
              initial='hidden'
              animate='enter'
              exit='exit'
              className='w-full text-xl font-semibold'
            >
              Confirm Email
            </motion.p>
            <div className='flex justify-between items-end w-full'>
              <div className='flex-1 flex flex-col justify-end'>
                <motion.p
                  variants={fadeIn(0.3)}
                  initial='hidden'
                  animate='enter'
                  exit='exit'
                  className='w-full text-xs'
                >
                  Enter the 4 digit number sent to:
                </motion.p>
                <motion.p
                  variants={fadeIn(0.3)}
                  initial='hidden'
                  animate='enter'
                  exit='exit'
                  className='text-primary mt-1 text-xs'
                >
                  {email}
                </motion.p>
              </div>
            </div>
            <div className='flex gap-4'>
              <motion.div
                variants={fadeIn(0.15)}
                initial='hidden'
                animate='enter'
                exit='exit'
                className='w-full'
              >
                <TextField
                  id='standard-basic'
                  variant='standard'
                  className='w-full text-center text-3xl'
                  placeholder='0'
                  inputRef={pin1}
                  onChange={(e) => onPinChange(1, e)}
                  type='number'
                  inputProps={{
                    min: 0,
                    style: { textAlign: 'center', fontSize: '3rem' },
                  }}
                />
              </motion.div>
              <motion.div
                variants={fadeIn(0.15)}
                initial='hidden'
                animate='enter'
                exit='exit'
                className='w-full'
              >
                <TextField
                  id='standard-basic'
                  variant='standard'
                  className='w-full'
                  placeholder='0'
                  inputRef={pin2}
                  onChange={(e) => onPinChange(2, e)}
                  type='number'
                  inputProps={{
                    min: 0,
                    style: { textAlign: 'center', fontSize: '3rem' },
                  }}
                />
              </motion.div>
              <motion.div
                variants={fadeIn(0.15)}
                initial='hidden'
                animate='enter'
                exit='exit'
                className='w-full'
              >
                <TextField
                  id='standard-basic'
                  variant='standard'
                  className='w-full'
                  placeholder='0'
                  inputRef={pin3}
                  onChange={(e) => onPinChange(3, e)}
                  type='number'
                  inputProps={{
                    min: 0,
                    style: { textAlign: 'center', fontSize: '3rem' },
                  }}
                />
              </motion.div>
              <motion.div
                variants={fadeIn(0.15)}
                initial='hidden'
                animate='enter'
                exit='exit'
                className='w-full'
              >
                <TextField
                  id='standard-basic'
                  variant='standard'
                  className='w-full'
                  placeholder='0'
                  inputRef={pin4}
                  onChange={(e) => onPinChange(4, e)}
                  type='number'
                  inputProps={{
                    min: 0,
                    style: { textAlign: 'center', fontSize: '3rem' },
                  }}
                />
              </motion.div>
            </div>
            <Button loading={loading} delay={0.05} onClick={confirmUserEmail}>
              Verify Email
            </Button>
          </div>
        </div>
      </Background>
    </>

  );
};

export default ConfirmEmail;
